export const showCreatePostModalRes = (state) => state.showCreatePostModal;
export const createPortfolioModal = (state) => state.createPortfolioModal;
export const showLegalDisclaimerModal = (state) =>
  state.showLegalDisclaimerModal;
export const showImageSliderModalRes = (state) => state.showImageSliderModal;
export const showSelectProfileModalRes = (state) =>
  state.showSelectProfileModal;
export const currentMentionCard = (state) => state.currentMentionCard;
export const isMentionHovered = (state) => state.mentionHovered;
export const isMentionCardHovered = (state) => state.mentionCardHovered;
export const passwordResetModal = (state) => state.passwordResetModal;
export const createPortfolioOperationModal = (state) =>
  state.createPortfolioOperationModal;
export const createOrderModal = (state) => state.createOrderModal;
export const createOrderTransactionModal = (state) =>
  state.createOrderTransactionModal;
export const helpCenterObjectRes = (state) => state.helpCenterObjectRes;
export const showProfileCardRes = (state) => state.showProfileCardRes;
export const portfolioEmptyStateModal = (state) =>
  state.portfolioEmptyStateModal;
export const klipyModal = (state) => state.klipyModal;
export const compareTickersModal = (state) => state.compareTickersModal;
export const compareTickersModalSelectedTicker = (state) =>
  state.compareTickersModal.selectedTicker;
export const itemsInComparison = (state) =>
  state.compareTickersModal.numberOfItemsInComparison;
export const comparePortfoliosModal = (state) => state.comparePortfoliosModal;
export const portfoliosInComparison = (state) =>
  state.comparePortfoliosModal.numberOfItemsInComparison;
export const manageTeamPortfolioModal = (state) =>
  state.manageTeamPortfolioModal;
export const createLeagueModal = (state) => state.createLeagueModal;
export const showPortfolioAssetOperationModalFooter = (state) =>
  state.showPortfolioAssetOperationModalFooter;
export const hasClosedEmailConfirmationBanner = (state) =>
  state.hasClosedEmailConfirmationBanner;
export const showNoDataAtDateError = (state) => state.showNoDataAtDateError;
export const companyTickersListModal = (state) => state.companyTickersListModal;
export const notificationsCenterMenuDrawer = (state) =>
  state.notificationsCenterMenuDrawer;
export const portfolioOptionsDrawer = (state) => state.portfolioOptionsDrawer;
export const portfolioGuideDrawer = (state) => state.portfolioGuideDrawer;
export const portfolioGuideModal = (state) => state.portfolioGuideModal;
export const homePageGuideDrawer = (state) => state.homePageGuideDrawer;
export const mobileSidebar = (state) => state.mobileSidebar;
export const portfolioOperationConfirmationComponent = (state) =>
  state.portfolioOperationConfirmationComponent;
export const portfolioSettingsModal = (state) => state.portfolioSettingsModal;
export const unrankedPortfolioConfirmationComponent = (state) =>
  state.unrankedPortfolioConfirmationComponent;
export const portfolioSelectorModal = (state) => state.portfolioSelectorModal;
export const openModals = (state) => state.openModals;
export const noEligiblePortfoliosDrawer = (state) =>
  state.noEligiblePortfoliosDrawer;
export const noEligiblePortfolioModal = (state) =>
  state.noEligiblePortfolioModal;
export const quickstartCompletionModal = (state) =>
  state.quickstartCompletionModal;
export const showTransactionTypesModal = (state) =>
  state.showTransactionTypesModal;
